import React from 'react';
import { Modal } from 'react-bootstrap';
import CapitalCoin from 'assets/images/backoffice/capital/capital-coin.png';
import styles from './Modal.css';
import Button from '../Button';

function ApplicationSentModal(props) {
  const { hideModal, content, info, buttonText } = props;
  return (
    <Modal
      show
      onHide={hideModal}
      dialogClassName={`${styles.dialog} modal-dialog`}
    >
      <Modal.Body>
        <div className={styles['content-wrapper']}>
          <img src={CapitalCoin} alt="capital-coin" className={styles.image} />
          <p className={styles.content} data-testid="content">
            {content}
          </p>
          <p className={styles.content} data-testid="info">
            {info}
          </p>
        </div>
        <div className={styles.footer}>
          <Button title={buttonText} onClick={hideModal} />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ApplicationSentModal;
